import React from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Tooltip from "common/DS/Tooltip";

import { LockOpenOutlined, LockOutlined, InfoIcon } from "common/DS/Icons";
import { CHECKIN_TYPE } from "lib/constants";

const KioskLockMessageText = (props, { t: _ }) => <span>{_("Your answers are anonymous.")}</span>;

KioskLockMessageText.contextTypes = {
    t: PropTypes.func,
};

const AlwaysOnLockMessageText = (props, { t: _ }) => (
    <span>{_("Responses are confidential.")}</span>
);

AlwaysOnLockMessageText.contextTypes = {
    t: PropTypes.func,
};

export const ConfidentialLockMessageText = (props, { t: _ }) => {
    const tooltipText = _(
        "Responses are connected to personal information, but your company pledges to keep the information private." +
            " Only select administrators can access personal information connected to your responses.",
    );
    return (
        <span className="flex flex-ac">
            {_("Responses are confidential.")}{" "}
            <Tooltip title={tooltipText}>
                <IconButton size="small" onClick={() => {}}>
                    <InfoIcon />
                </IconButton>
            </Tooltip>
        </span>
    );
};

ConfidentialLockMessageText.contextTypes = {
    t: PropTypes.func,
};

export const UnlockedNotConfidentialMessageText = (props, { t: _ }) => (
    <span className="color-red">{_("This answer is not confidential.")}</span>
);

UnlockedNotConfidentialMessageText.contextTypes = {
    t: PropTypes.func,
};

const ConfidentialityLock = ({ legalText, isAnonymous, isKiosk, checkinType, companyName }) => (
    <div>
        {legalText ||
            (isAnonymous ? (
                <>
                    <LockOutlined className="color-navy-medium" />
                    {isKiosk && <KioskLockMessageText />}
                    {!isKiosk && checkinType === CHECKIN_TYPE.ALWAYS_ON && (
                        <AlwaysOnLockMessageText />
                    )}
                    {!isKiosk && checkinType !== CHECKIN_TYPE.ALWAYS_ON && (
                        <ConfidentialLockMessageText companyName={companyName} />
                    )}
                </>
            ) : (
                <>
                    <LockOpenOutlined className="color-red" />
                    <span>
                        <UnlockedNotConfidentialMessageText />
                    </span>
                </>
            ))}
    </div>
);

ConfidentialityLock.contextTypes = {
    t: PropTypes.func,
};

ConfidentialityLock.propTypes = {
    legalText: PropTypes.string,
    isAnonymous: PropTypes.bool,
    isKiosk: PropTypes.bool,
    checkinType: PropTypes.number,
    companyName: PropTypes.string,
};

ConfidentialityLock.defaultProps = {
    legalText: "",
    isAnonymous: true,
    isKiosk: false,
    checkinType: null,
    companyName: "",
};

export default ConfidentialityLock;
